import React, { useContext } from "react";
import { LangCtx } from "../../../lib/context";
import { Link, useLocation } from "react-router-dom";
import "../Styles.css";

const WebPatientSideNavLinks = (props) => {
  const location = useLocation();
  const { l } = useContext(LangCtx);

  return (
    <>
      <ul className="flexMinHeightCol overFlowY">
        <li className="wsnItem">
          <Link
            to="/user-dashboard"
            className={
              location.pathname === "/user-dashboard"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/dashboard.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.dashboard}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/consultations"
            className={
              location.pathname === "/consultations"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/appointments-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.apptmnts}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/consultant-category"
            className={
              location.pathname === "/consultant-category"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/create-schedule-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.book_apptmnt}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/user-uploads"
            className={
              location.pathname === "/user-uploads"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/uploads-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.my_uploads}</span>
            </div>
          </Link>
        </li>

        <li className="wsnItem">
          <Link
            to='/user-invoices'
            className={
              location.pathname === "/user-invoices" ? "wsnLink wsnAcitve" : "wsnLink"
            }
          >
            <img
              src="/images/icons/invoice.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.invoices}</span>
            </div>
          </Link>
        </li>

        <li className="wsnItem">
          <Link
            to="/user-profile"
            className={
              location.pathname === "/user-profile"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/profile-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.my_profile}</span>
            </div>
          </Link>
        </li>


        <li className="wsnItem">
          <Link
            to="/user-settings"
            className={
              location.pathname === "/user-settings"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/settings-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.settings}</span>
            </div>
          </Link>
        </li>

        {/* <li className="wsnItem">
          <Link
            to="/user-helpSupport"
            className={
              location.pathname === "/user-helpSupport"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/help-support-icon.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.help_and_support}</span>
            </div>
          </Link>
        </li> */}
        <li className="wsnItem">
          <a className='wsnLink' href="https://help.instavc.com/inconsult" target="_blank">
            <img src='/images/icons/play-button.png' alt='help' className='linkIcon invertWhite' />
            <div className="linkTxtBlock">
              <span>{l.help_center}</span>
            </div>
          </a>
        </li>

      </ul>
      <ul className="flexAutoCol btmGrp">
        <li className="wsnItem">
          <Link
            onClick={props.handleLogout}
            className={
              location.pathname === "/" ? "wsnLink wsnAcitve" : "wsnLink"
            }
          >
            <img
              src="/images/icons/logout-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.logout}</span>
            </div>
          </Link>
        </li>

      </ul>
    </>
  );
};

export default WebPatientSideNavLinks;